import Typography from '@mui/material/Typography';
import {
  Alert,
  Box,
  CircularProgress,
  Divider,
  IconButton,
  Paper,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import { ShipmentImage } from '../../../interfaces/ShipmentImage/ShipmentImage';
import { sharedColors, sharedStyles } from '../../../utils/Style';

type ShipmentImagesProps = {
  isReadOnly?: boolean;
  waitingForBarcodeScan?: boolean;
  images: ShipmentImage[];
  onDelete?: (image: ShipmentImage, index: number) => void;
  loading: boolean;
};

export const ShipmentImages = (props: ShipmentImagesProps) => {
  return (
    <Paper
      sx={{
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        boxSizing: 'border-box',
      }}
    >
      <Typography sx={{ ...sharedStyles.h5, fontWeight: 'bold' }}>
        Sipariş Fotoğrafları
      </Typography>

      <Divider />

      {!props.isReadOnly &&
        !props.images.length &&
        !props.waitingForBarcodeScan && (
          <Alert severity='warning'>
            Lütfen devam etmeden önce en az 1 adet fotoğraf ekleyiniz.
          </Alert>
        )}

      {props.waitingForBarcodeScan && (
        <Alert severity='warning'>Lütfen önce barkodları okutunuz</Alert>
      )}

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 1.5,
          maxWidth: '100%',
          overflowX: 'auto',
        }}
      >
        {props.loading ? (
          <CircularProgress size={24} />
        ) : (
          props.images.map((image, i) => (
            <Box
              key={i}
              sx={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
              }}
            >
              <Box
                component='img'
                src={image.image}
                sx={{ height: 300, width: 'auto' }}
              />

              {!!props.onDelete && (
                <IconButton
                  size='small'
                  onClick={() => props.onDelete?.(image, i)}
                  disabled={props.loading}
                  sx={{
                    position: 'absolute',
                    top: 4,
                    right: 4,
                    backgroundColor: sharedColors.statusRed,
                    color: sharedColors.white,
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              )}

              <IconButton
                size='small'
                component='a'
                href={image.image}
                download
                target='_blank'
                rel='noopener noreferrer'
                sx={{
                  position: 'absolute',
                  top: 4,
                  left: 4,
                  backgroundColor: sharedColors.primary,
                  color: sharedColors.white,
                }}
              >
                <DownloadIcon />
              </IconButton>
            </Box>
          ))
        )}
      </Box>
    </Paper>
  );
};
